<template>
  <v-container fluid>
    <v-flex lg12 hidden-md-and-down>
      <front-navigation></front-navigation>
    </v-flex>
    <br>
    <v-container fluid>
    <v-layout row wrap>
      <v-flex lg4 md4 sm12 xs12 >
          <side-bar></side-bar>
      </v-flex>
      <v-flex lg8 md8 xs12 sm12>
          <v-container fluid>
            <v-flex lg11 md11>
                <search></search>
            </v-flex>
            <v-flex lg11 md12>
              <v-toolbar color="primary" dark tabs>
                <v-tabs
                  centered
                  color="primary"
                  slot="extension"
                  slider-color="white"
                  v-model="model"
                >
                  <v-tab
                    :key="1"
                  >
                    <span>Step 2 - Accommodation</span>
                  </v-tab>
                  <v-tab
                    :key="2"
                  >
                    <span>
                    Step 3 - Activities
                    </span>
                  </v-tab>
                  <v-tab
                    :key="3"
                  >
                    <span>
                    Step 4 - Payment
                    </span>
                  </v-tab>
                </v-tabs>
              </v-toolbar>
              <v-tabs-items v-model="model">
                <v-tab-item
                  :key="1"
                >
                  <v-layout row wrap fill-height>
                    <v-flex lg12 md12>
                      <v-card flat >
                        <facility-booking></facility-booking>
                        <v-container fluid>
                          <v-btn :depressed="true" small block color="warning" @click="model = 1">Skip Facilities/Done with Accommodation</v-btn>
                        </v-container>
                      </v-card>
                    </v-flex>
                    <hr>
                    <v-flex lg12 md12 sm12 xs12 >
                      <v-card flat>
                        <v-container row wrap>
                          <v-flex lg6 md12>
                            <v-container fluid style="margin-left: 3%">
                              <h3 class="earth-color">{{singleFacility.name}}</h3>
                              <span v-if="singleFacility.accomodation_type_id === 'Pelican' && singleFacility.facility_type_id === 'Accomodation'">
                                <p>Price Packs</p>
                                <v-chip v-for="(price, key) in developPricePacks(singleFacility)" :key="key"><span>From  <b>{{price.lower_limit}}</b> to <b>{{price.upper_limit}}</b> : <b>{{$localCurrency}} {{$roundOff(convert1(price.currency, price.price).amount)}}</b></span></v-chip>
                              </span>
                              <span v-else-if="singleFacility.facility_type_id === 'Accomodation'">
                                <p>Price {{$localCurrency}} {{$roundOff(convert1(singleFacility.price[0].currency_type, singleFacility.price[0].mandatory_price).amount)}}</p>
                              </span>
                              <span  v-else-if="singleFacility.facility_type_id === 'Camping Sites'">
                                <p>{{$localCurrency}} {{$roundOff(convert1(singleFacility.price[0].currency_type, singleFacility.price[0].mandatory_price).amount)}} exclusive of night charges</p>
                                <h5>Price {{$localCurrency}} {{$roundOff(convert1(singleFacility.price[0].currency_type, singleFacility.price[0].child_price).amount)}} - {{$localCurrency}} {{$roundOff(convert1(singleFacility.price[0].currency_type, singleFacility.price[0].adult_price).amount)}}</h5>
                              </span>
                              <!--<span v-if="singleFacility.facility_type_id === 'Accomodation' && singleFacility.pricing_status === 'true'">-->
                              <!--<h6 v-if="singleFacility.price.currency_type === 'KES' && browserCurrency === 'KES'">Price KES {{singleFacility.price.mandatory_price}}</h6>-->
                              <!--<h6 v-if="singleFacility.price.currency_type === 'KES' && browserCurrency === 'USD'">Price {{convertToUsd(singleFacility.price.mandatory_price)}}</h6>-->
                              <!--<h6 v-if="singleFacility.price.currency_type === 'USD' && browserCurrency === 'KES'">Price {{convertToKes(singleFacility.price.mandatory_price)}}</h6>-->
                              <!--<h6 v-if="singleFacility.price.currency_type === 'USD' && browserCurrency === 'USD'">Price $ {{singleFacility.price.mandatory_price}}</h6>-->
                              <!--</span>-->
                              <!--<span v-if="singleFacility.facility_type_id === 'Accomodation' && singleFacility.pricing_status === 'false'">-->
                              <!--<h6>No Price Set Yet</h6>-->
                              <!--</span>-->
                              <!--<span v-if="singleFacility.facility_type_id === 'Camping Sites' && singleFacility.pricing_status === 'true'">-->
                              <!--<h5 v-if="singleFacility.price.currency_type === 'KES' && browserCurrency === 'KES'">(KES {{singleFacility.price.mandatory_price}}) exclusive of night charges</h5>-->
                              <!--<h5 v-if="singleFacility.price.currency_type === 'KES' && browserCurrency === 'USD'">({{convertToUsd(singleFacility.price.mandatory_price)}}) exclusive of night charges</h5>-->
                              <!--<h5 v-if="singleFacility.price.currency_type === 'USD' && browserCurrency === 'KES'">({{convertToUsd(singleFacility.price.mandatory_price)}}) exclusive of night charges</h5>-->
                              <!--<h5 v-if="singleFacility.price.currency_type === 'USD' && browserCurrency === 'USD'">(${{singleFacility.price.mandatory_price}}) exclusive of night charges</h5>-->
                              <!--&lt;!&ndash;<h5 v-if="singleFacility.citizen_child_price !== null">Price from {{convertCurrency(singleFacility.citizen_child_price.data.citizen_child_price)}} - {{convertCurrency(singleFacility.non_resident_adult_price[0])}}</h5>&ndash;&gt;-->
                              <!--<h6 v-if="singleFacility.price.currency_type === 'KES' && browserCurrency === 'KES'">Price KES {{singleFacility.price.child_price}} - KES {{singleFacility.price.adult_price}}</h6>-->
                              <!--<h6 v-if="singleFacility.price.currency_type === 'KES' && browserCurrency === 'USD'">Price {{convertToUsd(singleFacility.price.child_price)}} - {{convertToUsd(singleFacility.price.adult_price)}}</h6>-->
                              <!--<h6 v-if="singleFacility.price.currency_type === 'USD' && browserCurrency === 'KES'">Price {{convertToUsd(singleFacility.price.child_price)}} - {{convertToKes(singleFacility.price.adult_price)}}</h6>-->
                              <!--<h6 v-if="singleFacility.price.currency_type === 'USD' && browserCurrency === 'USD'">Price ${{singleFacility.price.child_price}} - ${{singleFacility.price.adult_price}}</h6>-->
                              <!--</span>-->
                              <!--<span v-if="singleFacility.facility_type_id === 'Camping Sites' && singleFacility.pricing_status === 'false'">-->
                              <!--<h6 class="earth">No Price Set Yet</h6>-->
                              <!--</span>-->
                              <br>
                              <span v-html="singleFacility.description"></span>
                            </v-container>
                          </v-flex>

                          <v-flex lg6 md12>
                            <v-container fluid>
                              <img :src="singleFacility.thumbnail" alt="" width="100%" class="img-rounded">
                            </v-container>
                          </v-flex>
                        </v-container>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-tab-item>
                <v-tab-item
                  :key="2"
                >
                  <v-layout row wrap>
                      <v-flex lg12 md12>
                        <v-card flat>
                          <v-flex lg11 ml-4>
                            <inventory-booking></inventory-booking>
                          </v-flex>
                          <v-container fluid>
                            <v-btn :depressed="true" small block color="warning" @click="model = 2">Skip Activities/Done with Activities</v-btn>
                          </v-container>
                        </v-card>
                      </v-flex>
                      <hr>
                      <v-flex lg12 md12 style="height: 50vh">
                        <v-card flat>
                          <v-container row wrap style="margin-left: 1%">
                            <v-flex lg6 md12>
                              <v-container fluid>
                                <h3 class="earth-color">{{singleInventory.name}}</h3>
                                <span v-if="singleInventory.pricing_status === 'true'">
                                <h6 class="" v-if="browserCurrency === 'KES' && singleInventory.price.currency_type_id === 'USD'">Child Price: {{convertToKes(singleInventory.price.child_price)}}. Adult Price: {{convertToKes(singleInventory.price.adult_price)}}</h6>
                                <h6 class="" v-if="browserCurrency === 'KES' && singleInventory.price.currency_type_id === 'KES'">Child Price: KES {{(singleInventory.price.child_price)}}. Adult Price: KES {{(singleInventory.price.adult_price)}}</h6>
                                <h6 class="" v-if="browserCurrency === 'USD' && singleInventory.price.currency_type_id === 'USD'">Child Price: ${{(singleInventory.price.child_price)}}. Adult Price: ${{(singleInventory.price.adult_price)}}</h6>
                                <h6 class="" v-if="browserCurrency === 'USD' && singleInventory.price.currency_type_id === 'KES'">Child Price: {{convertToUsd(singleInventory.price.child_price)}}. Adult Price: {{convertToUsd(singleInventory.price.adult_price)}}</h6>
                                </span>
                                <br>
                                <span v-html="singleInventory.description"></span>
                              </v-container>
                            </v-flex>
                            <v-flex lg6 md12>
                              <v-container fluid>
                                <img :src="singleInventory.thumbnail" alt="" width="100%" class="img-rounded">
                              </v-container>
                            </v-flex>
                          </v-container>
                        </v-card>
                      </v-flex>
                  </v-layout>

                </v-tab-item>
                <v-tab-item
                  :key="3"
                >
                  <v-card flat>
                    <booking-information></booking-information>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-container>
      </v-flex>
    </v-layout>
      {{modelConsole}}
    </v-container>
  </v-container>
</template>

<script>
import FrontNavigation from '../Repeated/FrontNavigation'
import Search from '../Repeated/Search'
import Activities from '../Repeated/Activities'
import CampSites from '../Repeated/CampSites'
import Accomodations from '../Repeated/Accomodation'
import SideBar from '../Repeated/SideBar'
import InventoryBooking from '../../Back/Bookings/Snippets/InventoryBooking'
import FacilityBooking from '../../Back/Bookings/Snippets/FacilityBooking'
import BookingInformation from './BookingInformation'
export default {
  components: {
    BookingInformation,
    FacilityBooking,
    InventoryBooking,
    SideBar,
    Accomodations,
    CampSites,
    Activities,
    Search,
    FrontNavigation },
  data () {
    return {
      model: null
    }
  },
  created () {
    if (JSON.parse(localStorage.getItem('user_data')).check_in.length === 0 || JSON.parse(localStorage.getItem('user_data')).check_out.length === 0) {
      this.$router.push({
        name: 'Index'
      })
    } else {
      var data = {
        check_in_date: JSON.parse(localStorage.getItem('user_data')).check_in,
        check_out_date: JSON.parse(localStorage.getItem('user_data')).check_out
      }
      // changed to prevent public booking viewing facility
      this.$store.dispatch("check_date_facility_public_availability", data);
      // this.$store.dispatch('check_date_facility_availability', data)
    }
  },
  computed: {
    modelConsole () {
      return null
    }
  },
  methods: {
    openExpress: function () {
      this.$router.push({ name: 'ExpressCheckout' })
    }
  }
}
</script>

<style scoped>

</style>
